import { styled } from "@linaria/react";
import { StyledNotice } from "./Notice/StyledNotice";
import { breakpoints } from "../../styles/utils/vars";
export const StyledMain = /*#__PURE__*/styled('div')({
  name: "StyledMain",
  class: "StyledMain_sac940a"
});
export const StyledSide = /*#__PURE__*/styled('div')({
  name: "StyledSide",
  class: "StyledSide_s1ad4j7v"
});
export const StyledNote = /*#__PURE__*/styled('div')({
  name: "StyledNote",
  class: "StyledNote_s1t0mcjn"
});

require("./StyledNote.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledNote.tsx");